import React, { useState } from "react";
import {
  FormControl,
  FormLabel,
  Input,
  Button,
  VStack,
  Box,
  Flex,
  useToast,
  InputGroup,
  InputRightElement,
  IconButton,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import {backendBaseURL} from '../AppConstants';
const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const toast = useToast();

  const [loading, setLoading] = useState(false);
  
  const handleLoginwithAuth = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${backendBaseURL}/login`,
        { email, password }
      );
      if (response.data.token) {
        localStorage.setItem("token", response.data.token);
        navigate("/home");
        toast({
          position: "top",
          title: "Successfully Logged In",
          description: `${email} has been successfully logged in`,
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      } else {
        toast({
          position: "top",
          title: "Incorrect Credentials",
          description: "Incorrect Credentials",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Login failed:", error.response.data.message);
      toast({
        position: "top",
        title: `${error.response.data.message}`,
        description: "An error occurred during login. Please try again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleForgetPassword = async () => {
    toast({
      position: "top",
      title: "Redirecting to password reset email link",
      status: "warning",
      duration: 3000,
      isClosable: true,
    });
    setTimeout(() => {
      navigate("/set-email");
    }, 3000);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLoginwithAuth();
    }
  };

  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Flex
      minHeight="100vh"
      alignItems="center"
      justifyContent="center"
      px={{ base: 4, sm: 6, md: 8 }} // Adjust padding based on screen size
    >
      <VStack spacing={4} align="stretch" w="100%" maxW="md">
        <Box p={8} borderWidth={1} borderRadius={8} boxShadow="lg" w="100%">
          <FormControl id="email">
            <FormLabel>Email address</FormLabel>
            <Input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              onKeyPress={handleKeyPress}
            />
          </FormControl>

          <FormControl mt={4} id="password">
            <FormLabel>Password</FormLabel>
            <InputGroup>
              <Input
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                onKeyPress={handleKeyPress}
              />
              <InputRightElement width="2.5rem">
                <IconButton
                  h="1.75rem"
                  size="sm"
                  onClick={handleTogglePassword}
                  icon={showPassword ? <ViewOffIcon /> : <ViewIcon />}
                />
              </InputRightElement>
            </InputGroup>
          </FormControl>
          <Button
            mt={2}
            // onClick={handleForgetPassword}
            variant="link"
            color="teal.500"
            textAlign="left"
            w="100%"
          >
            Forgot Password?
          </Button>
          <Button
            mt={4}
            onClick={handleLoginwithAuth}
            bgGradient="linear(to-r, teal.500, teal.100)"
            _hover={{ bgGradient: "linear(to-r, teal.100, teal.500)" }}
            w="100%"
            isLoading={loading}
            loadingText="Logging In"
          >
            Login
          </Button>
        </Box>
        <Button
          mt={2}
          onClick={() => navigate("/home")}
          variant="link"
          color="teal.500"
          textAlign="left"
          w="100%"
        >
          Let's Start Demo
        </Button>
      </VStack>
    </Flex>
  );
};

export default AdminLogin;
